import AdminAccountSetupLayoutComponent from '@/components/layouts/admin-account-setup-layout/admin-account-setup-layout.component';
import AdminDatabaseSetupLayoutComponent from '@/components/layouts/admin-database-setup-layout/admin-database-setup-layout.component';
import AdminLayoutComponent from '@/components/layouts/admin-layout/admin-layout.component';
import {PERMISSION_KEYS} from '@/globals';
import {WORK_PERMITS_SCOPES} from '@/sdk';
import {RouteConfig} from 'vue-router';
import UnauthorizedComponent from '../client/unauthorized/unauthorized.component.vue';
import UserSetupComponent from '../user-setup/user-setup.component';
import AccountSetupComponent from './account-setup/account-setup.component';
import DustDbComponent from './dust-db/dust-db.component';
import FieldsDbComponent from './fields-db/fields-db.component';
import GasDbComponent from './gas-db/gas-db.component';

export const AdminPanelRoutes: Array<RouteConfig> = [
    {
        path: '/admin-panel',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                name: 'admin-panel',
                redirect: {name: 'fields-db'},
            },
            {
                path: 'unauthorized',
                name: 'admin-unauthorized',
                component: UnauthorizedComponent,
                meta: {
                    title: 'Unauthorized',
                    description: 'Unauthorized Access page',
                },
            },
            {
                path: 'database-setup',
                name: 'database-setup',
                component: AdminDatabaseSetupLayoutComponent,
                children: [
                    {
                        path: 'fields-db',
                        name: 'fields-db',
                        component: FieldsDbComponent,
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                            permissions: [PERMISSION_KEYS.ADMIN_FIELDS_DB_VIEW],
                        },
                    },
                    {
                        path: 'gas-db',
                        name: 'gas-db',
                        component: GasDbComponent,
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                            permissions: [PERMISSION_KEYS.ADMIN_GAS_DB_VIEW],
                        },
                    },
                    {
                        path: 'dust-db',
                        name: 'dust-db',
                        component: DustDbComponent,
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                            permissions: [PERMISSION_KEYS.ADMIN_DUST_DB_VIEW],
                        },
                    },
                    {
                        path: 'inspection-forms-db',
                        name: 'inspection-forms-db',
                        component: () => import('./inspection-forms-db/inspection-forms-db.component.vue'),
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                            permissions: [PERMISSION_KEYS.ADMIN_INSPECTION_FORMS_DB_VIEW],
                        },
                        children: [
                            {
                                path: 'inspection-form-setup/:id',
                                name: 'inspection-form-setup',
                                component: () => import('./inspection-forms-db/inspection-form-setup/inspection-form-setup.component.vue'),
                            },
                        ],
                    },
                    {
                        path: 'global-work-permits',
                        name: 'global-work-permits',
                        component: () => import('./work-permits-db/work-permits-db.component.vue'),
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                            permissions: [PERMISSION_KEYS.ADMIN_WORK_PERMIT_DB_VIEW],
                        },
                        props: route => ({scope: WORK_PERMITS_SCOPES.GLOBAL}),
                    },
                ],
            },
            {
                path: 'account-setup',
                component: AdminAccountSetupLayoutComponent,
                children: [
                    {
                        path: '',
                        name: 'account-setup',
                        redirect: {name: 'account-list'},
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                        },
                    },
                    {
                        path: 'account-list',
                        name: 'account-list',
                        component: AccountSetupComponent,
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                            permissions: [PERMISSION_KEYS.ADMIN_ACCOUNT_LIST_VIEW],
                        },
                    },
                    {
                        path: ':accountId/users',
                        name: 'account-users',
                        component: UserSetupComponent,
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                            permissions: [PERMISSION_KEYS.ADMIN_ACCOUNT_USERS_VIEW],
                        },
                    },
                    {
                        path: 'work-permits/:accountId',
                        name: 'account-work-permits',
                        component: () => import('./work-permits-db/work-permits-db.component.vue'),
                        meta: {
                            title: 'Fields Database',
                            description: 'Fields Database page',
                            permissions: [PERMISSION_KEYS.ADMIN_WORK_PERMIT_BY_ACCOUNT_VIEW],
                        },
                        props: route => ({scope: WORK_PERMITS_SCOPES.ACCOUNT}),
                    },
                ],
            },
        ],
    },
];
